import React, { FunctionComponent, useState, useEffect, useRef } from 'react';
import { Button, Icon, Loader, Modal } from '@scuf/common';
import { EMPTY_NOTES_TEXT, COMMENT_TYPE, ERROR_MSG_FOR_USER_RESPONSE, COMMENT_ACTION, OPPORTUNITIES_API_PATHS, IMAGE_NOT_FOUND } from '../../../../constants/constants';
import axios from '../../../../utils/APIUtils';
import moment from 'moment';
import { useSelector } from 'react-redux';
import addNotesIcon from '../../../../images/add-notes.png';
import { useAppDispatch } from '../../../../store';
import { getCommentSelector, getCommentsDetail, } from '../../../../slices/allOpportunitySlice';
import { toast, Zoom } from 'react-toastify';
import { Snackbar } from '../../../Snackbar/Snackbar';
import { getUserInfo } from '../../../../slices/userProfileSlice';
import './Notes.scss';
import "../../NewCardDesign/CommonStyle.scss";
import FontIcon from 'src/components/FontIcon/FontIcon';
import FilesIcon from 'src/images/files-icon.svg';

interface INotesProps {
  onClose: Function;
  opportunityId: any;
  opportunityStatus: string;
  open?: boolean;
  opportunityObjectName: any;
  role_name?: string;
  isAuditTrail?:boolean;
  isAllAnomalyPage?:boolean
}
const Notes: FunctionComponent<INotesProps> = (props) => {
  type ToastType = 'loading' | 'failure' | 'success';
  const { status: commentsStatus, data: commentsData } = useSelector(getCommentSelector);
  const [acceptActionInProgress, setAcceptActionInProgress] = useState(false);
  const [opportunityDetailLoading] = useState(true);
  const dispatch = useAppDispatch();
  const modalRef = useRef();
  const [imageObjects, setImageObjects] = useState<any[]>([]);
  const [cachedImagesCount, setCachedImagesCount] = useState<number>(0);
  const [openModal, setOpenmodal] = useState<boolean>(false);
  const [viewFileIndex, setViewFileindex] = useState<number>(0);
  const [commemtList, setCommentList] = useState<any[]>([]);
  const [defaultActivityCount, setDefaultActivityCount] = useState(3);
  const [expantActivity, setExpantActivity] = useState("View More");

  useEffect(() => {
    dispatch(getCommentsDetail(props.opportunityId));
  }, []);

  useEffect(() => {
    if (commentsData && commentsData.activity && commentsData.activity.length > 0) {
      let imagePromises: any[] = [];
      commentsData.activity.forEach((comment: any, index: number) => {
        imagePromises.push({
          index: index,
          key: index,
          file_name: '',
          data: null,
          blobData: null
        })
      });
      setImageObjects(imagePromises)
      let res: any = props.isAuditTrail ? [...commentsData.activity].reverse().slice(0, defaultActivityCount) : commentsData.activity;
      setCommentList(res);

    }
  }, [commentsData, defaultActivityCount]);

  const handleViewMore = () => {
    if (expantActivity === "View More") {
      setExpantActivity("View Less");
      if (commentsData) {
        setDefaultActivityCount(commentsData.activity.length);
      }
    } else if (expantActivity === "View Less") {
      setExpantActivity("View More")
      setDefaultActivityCount(3);
    }
  }

  const downloadFileStatusToast = (type: ToastType) => {
    if (type === 'loading') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-info"
            root="common"
            size="large"
            color="#007ad9"
            className="status-indicator-icon"
          />{' '}
          Downloading file. It may take few minutes to complete.{' '}
        </div>
      ); // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'success') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-check"
            root="common"
            size="large"
            color="#279d2b"
            className="status-indicator-icon"
          />
          File downloaded successfully.{' '}
        </div>
      ); // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'failure') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-stop"
            root="common"
            size="large"
            color="#BE271C"
            className="status-indicator-icon"
          />
          <p>File download operation failed.</p>
        </div>
      ); // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    }
  };



  const downladFile = async (
    insightId: number,
    storedFileName?: string,
    fileName?: string) => {
    return axios
      .get(
        `${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/download?file_name=${fileName}&stored_file_name=${storedFileName}`,
        { responseType: 'blob' }
      )
  }

  const convertBlobToBase64 = async (blob: any) => { // blob data
    return await blobToBase64(blob);
  }

  const blobToBase64 = (blob: any) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  const onClickDownloadFile = (index: number) => {
    const data = imageObjects[index]
    const url = window.URL.createObjectURL(new Blob([data.blobData]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${data.file_name ? decodeURIComponent(data.file_name) : props.opportunityId}`);
    document.body.appendChild(link);
    link.click();
    downloadFileStatusToast('success');
  }

  // download document API
  const openFileModal = async (
    index: number,
    insightId: number,
    storedFileName?: string,
    fileName?: string,
  ) => {
    downloadFileStatusToast('loading');
    setOpenmodal(true);
    setViewFileindex(index);
    if (!imageObjects[index]?.data) {
      downladFile(insightId, storedFileName, fileName)
        .then(async (response) => {
          let files_new: any[] = imageObjects;
          files_new[index].data = await convertBlobToBase64(response.data);
          files_new[index].blobData = response.data;
          files_new[index].file_name = fileName;
          setImageObjects(files_new);
          setCachedImagesCount(cachedImagesCount + 1);
        })
        .catch((err) => {
          downloadFileStatusToast('failure');
          console.log(' error ', err);
        });
    }
  };

  const isImageFile = (file_name: string) => {
    let extensions = file_name.split('.');
    const image_extensions = ['png', 'jpeg', 'gif', 'jpg', 'PNG', 'JPG', 'JPEG'];
    let extension = extensions[extensions.length - 1]
    if ( extension && image_extensions.includes(extension)) {
      return true
    }
    return false;
  }

  const displayError = () => {
    return (
      <>
        {commentsStatus === 'error' && (
          <div className="notes-error-text">
            {ERROR_MSG_FOR_USER_RESPONSE}
          </div>
        )}
      </>
    )
  }

  const displayLoader = () => {
    return (
      <>
        {(commentsStatus === 'loading' || acceptActionInProgress) && (
          <Loader
            loading={opportunityDetailLoading}
            text="Fetching activity log..."
            minHeight="28vh"
            max-height="70vh"
            overlayColor="transparent"
          />
        )}
      </>
    )
  }

  const displayActionNode = (action: any) => {
    const actionOwnerEmail = action.action_owner_mail || action.action_owner_mail_id || action.action_owner_mailid;
    return (
      <div>
        {action.user_response === 'accept' ||
          action.user_response === 'accept-org-user' ? (
          <div>
            <div className="notes-node-name__comment">
              {COMMENT_ACTION.ACCEPT}
            </div>
            {action.reason && (
              <div className="notes-node_comment">
                Reason-{action.reason}
              </div>
            )}
   
            {
            action.training_name && (
              <div className="notes-node_comment">

            {action.training_name && (action.user_response === "accept" ? "Proposed Training name:" : "Training name:")} {action.training_name}
              </div>
            )}
            {action.target_date && (
              <div className="notes-node_comment">
                Target date : {action.target_date}
              </div>
            )}
            {actionOwnerEmail && (
              <div className="notes-node_comment">
                Action owner email : {actionOwnerEmail}
              </div>
            )}
            {action.remarks && (
              <div className="notes-node_comment">
                Remark-{action.remarks}
              </div>
            )}
          </div>
        ) : action.user_response === 'reject' ||
          action.user_response ===
          'reject-org-user' ? (
          <div>
            <div className="notes-node-name__comment">
              {COMMENT_ACTION.REJECT}
            </div>
            {action.reason && (
              <div className="notes-node_comment">
                Reason-{action.reason}
              </div>
            )}
            {action.remarks && (
              <div className="notes-node_comment">
                Remark-{action.remarks}
              </div>
            )}
          </div>
        ) : action.user_response === 'reopen' ? (
          <div>
            <div className="node-name__comment">
              {COMMENT_ACTION.REOPEN}
            </div>
            {action.reason && (
              <div className="notes-node_comment">
                Reason-{action.reason}
              </div>
            )}
            {action.remarks && (
              <div className="notes-node_comment">
                Remark-{action.remarks}
              </div>
            )}
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }

  const renderCommentType = (item: any) => {
    let element = null;
    switch (item.type) {
      case 'comment':
        element = (<div>{COMMENT_TYPE.COMMENT.toLowerCase()}</div>);
        break;
      case 'tracking-submit':
        element = (<div>{COMMENT_TYPE.TRACKINGSUBMIT}</div>);
        break;
      case 'tracking-complete':
        element = (<div>{COMMENT_TYPE.TRACKINGCOMPLETE}</div>);
        break;
      case 'action': {
        // G&H Trends: reviewer 'accept' saves one action_tracking row per (owner, reason), so action_details
        // holds duplicated entries per owner while tracking_details has the clean per-owner breakdown to render
        const isProposedAccept = item && item.action_details && item.action_details.length > 0 &&
          item.action_details[0].user_response === 'accept' && item.tracking_details && item.tracking_details.length > 0;
        element = (<div>
          {isProposedAccept ? (
            <div>
              <div className="notes-node-name__comment">
                {COMMENT_ACTION.ACCEPT}
              </div>
              {item.tracking_details.map((tracking: any, index: number) => (
                <div key={index} className="notes-node_comment-group">
                  {tracking.reason && (
                    <div className="notes-node_comment">
                      Reason-{tracking.reason}
                    </div>
                  )}
                  {tracking.email && (
                    <div className="notes-node_comment">
                      Proposed action owner email : {tracking.email}
                    </div>
                  )}
                  {tracking.training_name && (
                    <div className="notes-node_comment">
                      Proposed Training name: {tracking.training_name}
                    </div>
                  )}
                  {tracking.target_date && (
                    <div className="notes-node_comment">
                      Target date : {tracking.target_date}
                    </div>
                  )}
                  {tracking.comments && (
                    <div className="notes-node_comment">
                      Remark-{tracking.comments}
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            item &&
            item.action_details &&
            item.action_details.map((action: any) => (
              displayActionNode(action)
            ))
          )}
        </div>);
        break;
      }
      case 'more-context':
        element = (<div className="notes-node_more-context">
          {COMMENT_TYPE.MORE_CONTEXT}
          {item &&
            item.shared_to_users &&
            item.shared_to_users.map((users: any) => (
              <div className="node-type">
                {users.email.toLowerCase()}
              </div>
            ))}
        </div>);
        break;
      case 'tracking-open':
        element = (<div className="notes-node_more-context">
          {COMMENT_TYPE.TRACKINGOPEN}
          {item &&
            item.tracking_details &&
            item.tracking_details.map((users: any) => (<>
              <div className="node-type">
                {users.email.toLowerCase()}
              </div>
              <div>
                {users.reason && (
                  <div className="notes-node_comment">
                    Reason-{users.reason}
                  </div>
                )}

                {users.training_name && (
                  <div className="notes-node_comment">
                    Training name: {users.training_name}
                  </div>
                )}

                {users.target_date && (
                  <div className="notes-node_comment">
                    Target date : {users.target_date}
                  </div>
                )}

                {users.comments && (
                  <div className="notes-node_comment">
                    Comment-{users.comments}
                  </div>
                )}
              </div>
            </>
            ))}
        </div>);
        break;

      case 'tracking-reminder':
        element = (<div className="notes-node_more-context">
          {COMMENT_TYPE.TRACKINGREMINDER}
          {item &&
            item.shared_to_users &&
            item.shared_to_users.map((users: any) => (
              <div className="node-type">
                {users.email.toLowerCase()}
              </div>
            ))}
        </div>);
        break;

      case 'audit-action':
      case 'business-action':
        element = (item.audit_details && <div className="notes-node_more-context">
          {
            item.audit_details.audit_response.includes("audit-accept") ? "accepted" : item.audit_details.audit_response.includes("audit-reject") ? "rejected" : null
          }
          {
            item && item.audit_details && item.audit_details.audit_response.includes("business-accept") ? "accepted(business)" : item.audit_details.audit_response.includes("business-reject") ? "rejected(business)" : null
          }  {COMMENT_TYPE.AUDIT}

          {item &&
            item.audit_details.remarks &&
            <div className="notes-node_comment">
              Remark-{item.audit_details.remarks.toLowerCase()}
            </div>
          }
          {item &&
            item.audit_details.reasons &&
            <div className="notes-node_comment">
              Reasons-{item.audit_details.reasons.toLowerCase()}
            </div>
          }
        </div>);
        break;
      default:
        element = null;
    }
    return element;
  }

  const renderFile = (item: any, index: number) => {
    return (
      <>
        {item && item.file_details && item.file_details.file_name.length > 0 && (
          <div className="notes-node_comment" key={cachedImagesCount}>
            {COMMENT_TYPE.UPLOAD.toLowerCase()}-{' '}
            <div className='comment-image-container' key={imageObjects && imageObjects[index]?.data ? `image-node-${index}-${item.file_details.file_name.trim()}` : `image-node-${index}`}>
              {isImageFile(item.file_details.file_name) && <img
                src={imageObjects && imageObjects[index]?.data ? `${imageObjects[index].data}` : FilesIcon}
                alt={item.file_details.file_name}
                className={imageObjects[index]?.data ? 'evidence-file' : 'evidence-file-icon'}>
              </img>}
              {!isImageFile(item.file_details.file_name) &&
                <img
                  src={FilesIcon}
                  alt={item.file_details.file_name}
                  className={'evidence-file-icon'}>
                </img>
              }
              <FontIcon
                iconName='fa fa-external-link'
                iconSize="large"
                className="file-download-icon expand-file_icon"
                onClick={() =>
                  openFileModal(
                    index,
                    props.opportunityId,
                    encodeURIComponent(item.file_details.stored_file_name),
                    encodeURIComponent(item.file_details.file_name)
                  )
                }
              ></FontIcon>
              {imageObjects[index]?.data && <FontIcon
                iconName='fa fa-cloud-download'
                iconSize="large"
                className="file-download-icon download-file_icon"
                onClick={() =>
                  onClickDownloadFile(index)
                }
              ></FontIcon>}

            </div>
            <div>File Name: {item.file_details.stored_file_name}</div>
          </div>
        )}
      </>
    )
  }

  const renderImageModal = () => {
    const loaded = imageObjects && imageObjects[viewFileIndex]?.data;
    const isImage = isImageFile(imageObjects[viewFileIndex]?.file_name || '')
    return (
      <>
        {
          <Modal
            open={openModal}
            onClose={() => setOpenmodal(false)}
            closeIcon
            className='file-download-modal'>
            <Modal.Header>
              {imageObjects && imageObjects[viewFileIndex]?.file_name ? imageObjects[viewFileIndex]?.file_name : 'Fetching File'}
              <div className="right">
                <Button
                  content='Download'
                  className='content-download-icon'
                  onClick={() => onClickDownloadFile(viewFileIndex)}
                >
                </Button>
              </div>
            </Modal.Header>
            <Modal.Content>
              <div className='download-modal-content'>
                {loaded && isImage &&
                  <img
                    src={`${imageObjects[viewFileIndex].data}`}
                    alt={imageObjects[viewFileIndex].file_name}
                    className={'evidence-image'}>
                  </img>}
                {
                  loaded && !isImage &&
                  <>
                    <img
                      src={FilesIcon}
                      alt={imageObjects[viewFileIndex].file_name}
                      className={'evidence-file'}>
                    </img>
                    <div>{imageObjects[viewFileIndex].file_name}</div>
                  </>

                }
                {!loaded && <Loader
                  loading={true}
                  text="Fetching File"
                  minHeight="28vh"
                  max-height="70vh"
                  overlayColor="transparent"
                />}
              </div>
            </Modal.Content>
          </Modal>}
      </>

    )
  }

  return (
    <>
      <Modal.Content className={props.isAuditTrail?"new-notes-card no-height":"new-notes-card"}  >
        <div
          style={{ position: 'relative' }}
          data-testid="getInvoiceCard"
          className={props.isAllAnomalyPage?"anomaly-right-rail":""}
        >
          {displayLoader()}
          {displayError()}
          {commentsStatus === 'finished' && !acceptActionInProgress && commentsData && commentsData.activity &&
            commentsData.activity.length > 0 ? (
            <div >
            
              <div className="timeline-wrapper">
                {commentsData.activity &&
                 commemtList
                 .map((item: any, index: number) => (
                    <div className="notes-node" key={`comment-${index}`}>
                      <p className="notes-node_date">
                        {moment(item.created_on).format(
                          ' Do MMMM Y, dddd, h:mm A'
                        )}
                      </p>
                      <p className="notes-node_name">
                        <span className="type-comment">
                          {item.last_name + ', ' + item.first_name}
                        </span>
                        &nbsp;
                        {renderCommentType(item)}{' '}
                      </p>
                      <p>
                        {renderFile(item, index)}
                      </p>
                      <p className="notes-node_comment">{item.user_comment}</p>
                    </div>
                  ))}
                {props.opportunityStatus === 'open' && (
                  <div className="notes-node1">
                    <h3>Today</h3>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <>
              {commentsStatus === 'finished' && !acceptActionInProgress && (
                <div className="empty-notes">
                  <img src={addNotesIcon} alt={IMAGE_NOT_FOUND} />
                  <div className="empty-notes--description_empty">
                    {EMPTY_NOTES_TEXT}{' '}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        {
          props.isAuditTrail?       <div className="notes-node2">
          <div className="ViewMore" onClick={handleViewMore}>{expantActivity}</div>
        </div>:null
        }
      </Modal.Content>

      {renderImageModal()}
    </>
  );
};
export default Notes;
